import logo from '../../assets/logo.png';
import './SideBanner.scss';

const SideBanner = () => {
  return (
    <div className="left-banner">
      <div className="overlay">
        <div className="bot">
          <div className="logo">
            <img src={logo} alt="logo" />
            <div className="footer">
              <p>Copyright © {new Date().getFullYear()} - Vyadom Group. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBanner;

